import { HelpCircle as RiQuestionLine } from 'components/icons'
import { GRadio } from 'components/basic-blocks/g-radio'
import { GNewTooltip } from 'components/basic-blocks/g-tooltip/g-new-tooltip'
import { twMerge } from 'tailwind-merge'
import { DetectionModeProps } from './types'
import { HelpCircle as AiOutlineQuestionCircle } from 'components/icons'
import { GTooltip } from '../../../../../../../../components/basic-blocks'

export const detectionModeOptions = [
	{
		value: '1',
		name: 'Quiet',
		message:
			'In quiet mode, the system will be very tolerant of bad interactions with your ads.',
		labelClassName: 'absolute top-[25px] left-[-2px]'
	},
	{
		value: '2',
		name: 'Softer',
		message:
			'In soft mode, the system will treat low quality visitors lightly, while still detecting malicious actions.',
		labelClassName: 'absolute top-[25px] left-[-10px]'
	},
	{
		value: '3',
		name: 'Normal',
		message:
			'In normal mode, the system will detect both low quality traffic and malicious intent.',
		labelClassName: 'absolute top-[25px] left-[-13px]'
	},
	{
		value: '4',
		name: 'Stricter',
		message:
			'In strict mode, the system will be more restrictive towards suspicious actions.',
		labelClassName: 'absolute top-[25px] left-[-15px]'
	},
	{
		value: '5',
		name: 'Aggressive',
		message:
			'In aggressive mode, the system will react even on the slightest bad interaction. Use with caution!',
		labelClassName: 'absolute top-[25px] left-[-45px]'
	}
]

export const DetectionMode = ({
	detectionMode,
	setDetectionMode
}: DetectionModeProps) => {
	return (
		<div>
			<div className="text-t-default text-md flex flex-row items-center gap-x-1 mb-4">
				<span className="font-medium">Custom detection tuning</span>
				<GTooltip
					position="top"
					arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
					contentClassName="border-none font-grotesk mb-2 bg-t-smoke w-[300px] font-medium text-sm text-t-desc-gray"
					content="Adjust how aggressive the detection system should be."
				>
					<div>
						<AiOutlineQuestionCircle className="w-4 h-4 text-t-gray-hold" />
					</div>
				</GTooltip>
			</div>

			<div className="flex flex-col p-4">
				<div className="w-full flex justify-between">
					{detectionModeOptions.map((option, index) => (
						<div
							key={option.value}
							className={twMerge(
								'flex items-baseline h-6 relative',
								index !== detectionModeOptions.length - 1 ? 'w-full' : ''
							)}
						>
							<GTooltip
								arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
								contentClassName="border-none font-grotesk mb-2 bg-t-smoke w-[300px] font-medium text-sm text-t-desc-gray"
								key={option.value}
								content={option.message}
								position="top"
							>
								<div>
									<GRadio
										name={option.name}
										checked={detectionMode === option.value}
										onChange={(e) => setDetectionMode(e.target.value)}
										value={option.value}
										className="flex flex-col items-center"
										inputContainerClassName="mr-0"
									/>
								</div>
							</GTooltip>
							{index !== detectionModeOptions.length - 1 && (
								<div className="h-[2px] mx-2 w-full bg-t-checkbox"></div>
							)}
							<span className={`text-t-coupon ${option.labelClassName}`}>{option.name}</span>
						</div>
					))}
				</div>
			</div>
		</div>
	)
}
